/*
  LIORIVE — keeps the product page "Livraison" row in step with the cart.
  The row is rendered server-side from the cart at page load (snippets/liorive-info-rows.liquid);
  after an add to cart, Dawn publishes PUB_SUB_EVENTS.cartUpdate and the row is recomputed from
  /cart.js with the same threshold and the store's own money format. EUR carts only (the row is
  not rendered for other currencies).
*/
(() => {
  const formatMoney = (cents, format) => {
    const value = (cents / 100).toFixed(2);
    const [int, dec] = value.split('.');
    const group = (sep) => int.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals':
          return group(',');
        case 'amount_with_comma_separator':
          return `${group('.')},${dec}`;
        case 'amount_no_decimals_with_comma_separator':
          return group('.');
        case 'amount_with_space_separator':
          return `${group(' ')},${dec}`;
        default:
          return `${group(',')}.${dec}`;
      }
    });
  };

  const render = (el, total) => {
    const threshold = Number(el.dataset.threshold);
    const format = el.dataset.moneyFormat || '€{{amount_with_comma_separator}}';
    const thresholdText = formatMoney(threshold, format).replace(/[.,]00(?=\D*$)/, '');
    const remaining = threshold - total;
    if (total <= 0) {
      el.textContent = `Offerte dès ${thresholdText} d’achat.`;
    } else if (remaining > 0) {
      el.textContent = `Offerte dès ${thresholdText} d’achat. Plus que `;
      const strong = document.createElement('strong');
      strong.textContent = formatMoney(remaining, format);
      el.append(strong, ' avec votre panier.');
    } else {
      el.textContent = `Offerte pour votre commande : seuil de ${thresholdText} atteint.`;
    }
  };

  const refresh = () => {
    const rows = document.querySelectorAll('[data-lr-ship]');
    if (!rows.length) return;
    fetch(`${(window.routes && window.routes.cart_url) || '/cart'}.js`, { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((cart) => {
        if (cart.currency && cart.currency !== 'EUR') return;
        rows.forEach((el) => render(el, cart.total_price));
      })
      .catch(() => {});
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
  }
  // Back/forward cache restores the page as it was: re-read the cart.
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) refresh();
  });
})();
